import { object, string } from 'yup';

import { ANOTHER_VARIANT } from '../../constants/declineReasons.constants';

export type TGiftDeclineForm = {
  reason: string;
  declineReason: string;
};

export const validationSchema = object().shape({
  reason: string().label('The reason').trim().required('The reason needs to be filled in.').min(3).max(255),
});

export const validationSchemaWithReasons = object().shape({
  declineReason: string().label('The reason').required(),
  reason: string()
    .label('The reason')
    .when('declineReason', {
      is: ANOTHER_VARIANT,
      then: string().trim().required('The reason needs to be filled in.').min(3).max(255),
      otherwise: string(),
    }),
});
